import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, AlertTriangle, Info, XCircle } from 'lucide-react';
import { useWarningStore } from '../../store/warningStore';

export const UsageWarningBanner: React.FC = () => {
    const { usageWarning, usagePercentage } = useWarningStore();

    if (!usageWarning) return null;

    const config = {
        info: {
            color: 'bg-blue-50 border-blue-400 text-blue-700',
            icon: <Info className="w-5 h-5 text-blue-600" />,
            message: `You've used ${usagePercentage?.toFixed(1)}% of your monthly payment limit.`,
            showCta: false,
        },
        warning: {
            color: 'bg-yellow-50 border-yellow-400 text-yellow-700',
            icon: <AlertCircle className="w-5 h-5 text-yellow-600" />,
            message: `Warning! You've used ${usagePercentage?.toFixed(1)}% of your monthly payment limit.`,
            showCta: true,
        },
        critical: {
            color: 'bg-orange-50 border-orange-400 text-orange-700',
            icon: <AlertTriangle className="w-5 h-5 text-orange-600" />,
            message: `Critical! You've used ${usagePercentage?.toFixed(1)}% of your monthly payment limit. Upgrade your plan now.`,
            showCta: true,
        },
        exceeded: {
            color: 'bg-red-50 border-red-400 text-red-700',
            icon: <XCircle className="w-5 h-5 text-red-600" />,
            message: `Your monthly payment limit has been reached! New payments cannot be tracked. Upgrade immediately.`,
            showCta: true,
        },
    };

    const currentConfig = config[usageWarning];

    return (
        <div className={`border-l-4 p-4 mb-6 ${currentConfig.color}`}>
            <div className="flex items-start gap-3">
                <div className="flex-shrink-0">{currentConfig.icon}</div>
                <div className="flex-1">
                    <p className="text-sm font-semibold">{currentConfig.message}</p>
                    {currentConfig.showCta && (
                        <Link
                            to="/pricing"
                            className="inline-block mt-2 text-sm font-medium underline hover:no-underline"
                        >
                            Upgrade Plan →
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};
